import { render, staticRenderFns } from "./DestinosEcopetrolIndex.vue?vue&type=template&id=702642b3"
import script from "./DestinosEcopetrolIndex.vue?vue&type=script&lang=js"
export * from "./DestinosEcopetrolIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports